import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PublicRoutes() {
  const user = useSelector((state) => state.user);
  return user ? <Navigate to="/dashboard" /> : <Outlet />;
}
